import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'converLeads'
})
export class ConverLeadsPipe implements PipeTransform {

  transform(arreglo: any[], texto: string): any[] {
    console.log(arreglo, texto)
    if(!texto){
      return ;
    }

    if( arreglo.length === 0 ) {
      return;
    }
    // texto = texto.toLocaleLowerCase();

    const arr = arreglo.filter( item => item.idAdmin == texto);
    console.log(arr);
    return arr[0];
  }

}